'use strict';

module.exports.close = function($panel) {
    setTimeout(function() {
        require('./../../../services/structure/menu/mobile').close();
    }, parseFloat($panel.css('transition-duration')) * 1000);
};

